import React from 'react';
import { GraduationCap, Users, Globe, Award } from 'lucide-react';
import Container from '../../components/ui/Container';

const About = () => {
  const stats = [
    { icon: Users, value: '50,000+', label: 'Active Students' },
    { icon: GraduationCap, value: '1,000+', label: 'Expert Teachers' },
    { icon: Globe, value: '100+', label: 'Countries' },
    { icon: Award, value: '4.9/5', label: 'Satisfaction Rate' }
  ];

  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-24">
        <Container>
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6">Our Mission</h1>
            <p className="text-xl text-indigo-100">
              Empowering learners worldwide through personalized education and 
              connecting them with expert teachers who inspire growth and excellence.
            </p>
          </div>
        </Container>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <Container>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex p-4 rounded-full bg-indigo-50 text-indigo-600 mb-4">
                  <stat.icon className="w-8 h-8" />
                </div>
                <div className="text-3xl font-bold mb-2">{stat.value}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-gray-50">
        <Container>
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-8 text-center">Our Story</h2>
            <div className="prose lg:prose-lg mx-auto">
              <p className="text-gray-600 leading-relaxed">
                Founded in 2024, AcademiaHub emerged from a simple yet powerful idea: 
                education should be personalized, accessible, and transformative. 
                We believed that by connecting dedicated teachers with eager learners, 
                we could create an environment where knowledge flows freely and learning 
                becomes an exciting journey of discovery.
              </p>
              <p className="text-gray-600 leading-relaxed mt-6">
                Today, we're proud to have helped thousands of students achieve their 
                academic goals through one-on-one sessions with expert teachers. 
                Our platform continues to grow, innovate, and adapt to the evolving 
                needs of modern education.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <Container>
          <h2 className="text-3xl font-bold mb-12 text-center">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="inline-flex p-4 rounded-full bg-green-50 text-green-600 mb-4">
                <Users className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-semibold mb-4">Student First</h3>
              <p className="text-gray-600">
                Every decision we make prioritizes the learning experience and success 
                of our students.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="inline-flex p-4 rounded-full bg-blue-50 text-blue-600 mb-4">
                <Award className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-semibold mb-4">Excellence</h3>
              <p className="text-gray-600">
                We maintain high standards in teaching quality and platform experience.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="inline-flex p-4 rounded-full bg-purple-50 text-purple-600 mb-4">
                <Globe className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-semibold mb-4">Accessibility</h3>
              <p className="text-gray-600">
                Making quality education available to everyone, everywhere.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default About;